import { Authenticator } from '@aws-amplify/ui-react';
import { Suspense } from 'react';
import { CookiesProvider } from 'react-cookie';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';

import { store } from '@/app/store';
import { ErrorFallback } from '@/components/Elements/ErrorFallback/ErrorFallback';
import { HeadBlock } from '@/components/Elements/HeadBlock/HeadBlock';
// NOTE: jsonのプロファイルを利用する。store初期化前のため
import { serviceProfile as jsonServiceProfile } from '@/profile/serviceProfile';
import { AppRoutes } from '@/routes';
import { usePageTracking } from '@/utils/useTracking';

if (jsonServiceProfile?.profileName === 'shirahama-map') {
  await import('@/styles/wakayama-shirahama.css');
} else {
  // NOTE: 指定されたプロファイル以外は、スタイルが当てられていなかったため、デフォルトのスタイルを当てる様に修正
  await import('@/styles/spot-popup-default.css');
}

export const App = () => {
  usePageTracking(jsonServiceProfile);

  return (
    <Provider store={store}>
      <Authenticator.Provider>
        <CookiesProvider defaultSetOptions={{ path: '/' }}>
          <HelmetProvider>
            <HeadBlock />
            <ErrorBoundary FallbackComponent={ErrorFallback}>
              <Suspense>
                <AppRoutes />
              </Suspense>
            </ErrorBoundary>
          </HelmetProvider>
        </CookiesProvider>
      </Authenticator.Provider>
    </Provider>
  );
};

// Cypressからreduxのデータを参照する
// if (window.Cypress) {
//   window.store = store;
// }
